import { useOrbit } from '../store'
import type { ConnectionState } from '@hermes/shared'
import { getWebApp, isInTelegram, requestExpandedView } from '../telegram'

function stateLabel(state: ConnectionState): string {
  switch (state) {
    case 'open':
      return 'онлайн'
    case 'connecting':
      return 'подключение…'
    case 'error':
      return 'ошибка'
    case 'closed':
      return 'офлайн'
    default:
      return 'ожидание'
  }
}

function stateColor(state: ConnectionState): string {
  switch (state) {
    case 'open':
      return 'var(--color-accent-secondary)'
    case 'connecting':
      return 'var(--color-accent-warning)'
    case 'error':
      return 'var(--color-accent-danger)'
    default:
      return 'var(--color-text-muted)'
  }
}

export function Header() {
  const { state, model } = useOrbit()
  const inTg = isInTelegram()

  async function configurePin() {
    const pin = window.prompt('Придумай PIN из 6–12 цифр для входа с iPhone/iPad')?.trim() || ''
    if (!/^\d{6,12}$/.test(pin)) {
      window.alert('PIN должен содержать от 6 до 12 цифр.')
      return
    }
    const response = await fetch('/api/auth/pin/setup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Telegram-Init-Data': getWebApp()?.initData || '',
      },
      body: JSON.stringify({ pin }),
    })
    if (response.ok) window.alert('PIN сохранён. Теперь можно входить с отдельной иконки.')
    else window.alert('Не удалось сохранить PIN. Попробуй ещё раз.')
  }

  return (
    <header
      className="flex items-center justify-between border-b border-border-primary bg-bg-secondary px-4 py-3"
      style={{ paddingTop: 'calc(env(safe-area-inset-top) + 0.75rem)' }}
    >
      <div className="flex items-center gap-2">
        <span className="text-lg font-semibold tracking-wide">O.R.B.I.T.</span>
        {inTg && (
          <span className="rounded-full bg-accent-primary/10 px-2 py-0.5 text-[10px] font-medium text-accent-primary">
            TG
          </span>
        )}
      </div>
      <div className="flex items-center gap-3 text-xs">
        {inTg && (
          <button
            type="button"
            onClick={requestExpandedView}
            className="rounded-lg border border-border-primary bg-bg-tertiary px-2 py-1 text-[10px] text-text-secondary active:scale-95"
            title="Развернуть Mini App"
          >
            ↗ Развернуть
          </button>
        )}
        {inTg && (
          <button
            type="button"
            onClick={() => void configurePin()}
            className="rounded-lg border border-border-primary bg-bg-tertiary px-2 py-1 text-[10px] text-text-secondary active:scale-95"
            title="Настроить PIN для отдельной иконки"
          >
            PIN
          </button>
        )}
        {model && <span className="text-text-muted">{model}</span>}
        <span className="flex items-center gap-1.5">
          <span
            className="inline-block h-2 w-2 rounded-full"
            style={{ background: stateColor(state) }}
          />
          <span style={{ color: stateColor(state) }}>{stateLabel(state)}</span>
        </span>
      </div>
    </header>
  )
}
